// redux
import { useSelector } from 'react-redux';
import selectorUser from '@redux/user/selectors';
// permission
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';
import { useCheckPermissions } from 'hooks';
// utils
import { getData } from 'utils/storage';

import { useUserInfo } from 'hooks/auth/useUserInfo';

export const useBrokerHasInitiateBillingEvent = () => {
  const impersonateData = getData('impersonate');
  const {
    userInfo
  } = useUserInfo();
  const hasPermissionImpersonalInitiateBillingEvent = useCheckPermissions([
    {
      action: ABILITY_ACTION.IMPERSONATE,
      subject: ABILITY_SUBJECT.INITIATE_BILLING_EVENT,
    },
  ]);

  if (
    userInfo?.isImpersonating &&
    impersonateData?.impersonateType?.toLowerCase() === 'member'
  ) {
    if (hasPermissionImpersonalInitiateBillingEvent) return true;
    return false;
  }
  return true;
};
